import { Children } from 'react';
import Polyglot from 'node-polyglot';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import defaultMessages from 'i18n/aor/en';
import withContext from 'recompose/withContext';
import { connect } from 'react-redux';
import { missingTranslationReporter } from 'helpers/Logging/sentry';

const withI18nContext = withContext({
    translate: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
}, ({ locale, messages = {} }) => {
    const userMessages = messages[locale] || {};
    const polyglot = new Polyglot({
        locale,
        phrases: { ...defaultMessages, ...userMessages },
        onMissingKey: missingTranslationReporter,
    });

    return {
        locale,
        translate: polyglot.t.bind(polyglot),
    };
});

const TranslationProvider = ({ children }) => {
    return Children.only(children);
};

TranslationProvider.propTypes = {
    locale: PropTypes.string.isRequired,
    messages: PropTypes.object,
    children: PropTypes.element,
};

const mapStateToProps = (state) => {
    return {
        locale: state.locale,
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        null,
    ),
    withI18nContext,
);

export default enhance(TranslationProvider);



// WEBPACK FOOTER //
// ./src/i18n/Provider.js